module.exports = __webpack_public_path__ + "img/born2.05ce372c.png";